import React from 'react';
import { Outlet, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { MessageCircleHeart, Camera, MapPin, User, Loader2 } from 'lucide-react';
import { useApp } from '../context/AppContext';

const TABS = [
  { to: '/app/ask', label: 'Ask Vet', icon: MessageCircleHeart },
  { to: '/app/symptoms', label: 'Symptoms', icon: Camera },
  { to: '/app/vets', label: 'Find Vets', icon: MapPin },
  { to: '/app/profile', label: 'Profile', icon: User },
];

export default function AppShell() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { token, cats, loading } = useApp();

  if (loading) return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--coral))]" /></div>;
  if (!token) return <Navigate to="/auth" replace />;
  if (!cats.length) return <Navigate to="/onboarding" replace />;

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-background">
      <div className="flex-1 pb-24">
        <Outlet />
      </div>

      <nav className="fixed inset-x-0 bottom-0 z-20 mx-auto max-w-md border-t border-border bg-white/95 backdrop-blur">
        <div className="grid grid-cols-4">
          {TABS.map((t) => {
            const active = pathname === t.to || (t.to === '/app/ask' && pathname === '/app');
            const Icon = t.icon;
            return (
              <button key={t.to} onClick={() => nav(t.to)} className="flex flex-col items-center gap-1 py-2.5">
                <Icon className={`h-6 w-6 transition-colors ${active ? 'text-[hsl(var(--coral))]' : 'text-muted-foreground'}`} strokeWidth={active ? 2.4 : 1.9} />
                <span className={`text-[11px] font-semibold ${active ? 'text-[hsl(var(--coral))]' : 'text-muted-foreground'}`}>{t.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
